import { render, staticRenderFns } from "./AtlasesMap.vue?vue&type=template&id=001cc604&scoped=true&"
import script from "./AtlasesMap.vue?vue&type=script&lang=js&"
export * from "./AtlasesMap.vue?vue&type=script&lang=js&"
import style0 from "./AtlasesMap.vue?vue&type=style&index=0&id=001cc604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001cc604",
  null
  
)

export default component.exports